import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import PageHeader from 'components/PageHeader/PageHeader';
import { useEffect, useState } from 'react';
import { getOrganizations } from 'services/organisation.service';
import { getImpactReportTemplates } from 'services/impactReportTemplate.services';
import { getImpactReportModels } from 'services/impactReportModel.services';
import { getImpactReportById } from 'services/impactReport.services';
import EditImpactReportForm from 'components/EditImpactReportForm/EditImpactReportForm';
import { ImpactReportType } from 'types/impactReport.type';

export default function EditImpactReportPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const impactReportId = id || '';

  const [organisationList, setOrganisationList] = useState([]);
  const [impactReportTemplateList, setImpactReportTemplateList] = useState([]);
  const [impactReportModelList, setImpactReportModelList] = useState([]);
  const [impactReport, setImpactReport] = useState<ImpactReportType | null>(null);

  useEffect(() => {
    getOrganizations().then((response) => setOrganisationList(response.data));
    getImpactReportTemplates().then((response) => setImpactReportTemplateList(response.data));
    getImpactReportModels().then((response) => setImpactReportModelList(response.data));

    if (impactReportId) {
      getImpactReportById(impactReportId).then((response) => {
        setImpactReport(response);
      });
    }
  }, [impactReportId]);

  return (
    <Container>
      <PageHeader
        title={t('impactReportDetailsPage.titleDetails')}
        hasButton={false}
        hasBackButton={true}
      />
      {impactReport && (
        <EditImpactReportForm
          impactReportId={impactReportId}
          organisationList={organisationList}
          impactReportTemplateList={impactReportTemplateList}
          impactReportModelList={impactReportModelList}
          generationMode={impactReport.generationMode}
          generationFrequency={impactReport.generationFrequency}
        />
      )}
    </Container>
  );
}